import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import route from 'plugins/routes/dashboard';
import menuItem from './menuItem';
import subMenu from './subMenu';
import store from '../../../store';

export default ({ collapsed }) => {
  let str = '';
  const location = useLocation();
  const { pathname } = location,
    keywords = pathname.split('/');
  const mode = 'inline';
  const history = useHistory();
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([pathname]);
  const defaultOpenKeys = keywords.slice(1, keywords.length - 1).map((x) => {
    str += `/${x}`;
    return str;
  });

  useEffect(() => {
    setDefaultSelectedKeys([pathname]);
  }, [pathname]);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      setDefaultSelectedKeys([location.pathname]);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return (
    <>
      <div className="Logo">
        <img
          src="https://images.ceptesok.com/cdn-cgi/image/width=49,height=49,fit=pad,quality=100/logos/service-types/market-logo.svg"
          alt="Cepte Şok"
          style={{ width: 100 }}
        />
      </div>
      <Menu
        key={defaultSelectedKeys.join(',')}
        {...{ defaultOpenKeys, defaultSelectedKeys, mode }}
      >
        {setTree()}
      </Menu>
    </>
  );
};
function setTree() {
  const currentRoles = store().getState().auth.userIntrospect.roles;
  if (currentRoles?.find((role) => role === 'ROLE_ADMIN')) {
    route.routes
      .filter((x) => x.path === '/dinamik-kapasite-yonetimi')
      .map((x) => (x.menu = true));
    route.routes.forEach((route) => {
      if (route.path === '/tanimlar') {
        route.routes.forEach((subRoute) => {
          if (subRoute.path === '/kullanicilar') {
            subRoute.menu = true;
          }
        });
      }
    });
  }
  if (currentRoles?.find((role) => role === 'ROLE_ADMIN')) {
    route.routes.forEach((route) => {
      if (route.path === '/tanimlar') {
        route.routes.forEach((subRoute) => {
          if (
            subRoute.path === '/rotalama-parametreleri' ||
            subRoute.path === '/rotalama-parametre-profilleri' ||
            subRoute.path === '/rotalama-parametresi-degerleri'
          ) {
            subRoute.menu = true;
          }
        });
      }
    });
  }
  return setMenuTree();
}
function setMenuTree() {
  return route.routes
    .filter((routeItem) => routeItem.menu !== false)
    .map((routeItem) =>
      routeItem.routes
        ? subMenu('', routeItem.path, routeItem)
        : menuItem('', '', routeItem),
    );
}
